import { Download } from '@mui/icons-material';
import dayjs from 'dayjs';
import { enqueueSnackbar } from 'notistack';
import { useMemo, useState } from 'react';
import { CommodityManagementApi } from '../../../../../../Apis/Apis';
import { Constants } from '../../../../../../Core/Constants';
import { downloadFile } from '../../../../../../Helpers';
import { useLoadingState } from '../../../../../../Hooks';
import { StoneXRow } from '../../../../../StoneX';
import { StoneXButton, StoneXDatePicker } from '../../../../../StoneXMui';
import { ReportProps } from '../../ReportsPage';

// Batch report for Piedmont: the workbook is built server side from the report's default inputs,
// so the only choice here is the marking to market date.
export function PiedmontHedgingReport(props: ReportProps) {
  const { customerReportId } = props;

  const [quoteDate, setQuoteDate] = useState<Date | null>(props.quoteDate);
  const quoteDateString = useMemo(() => (quoteDate ? dayjs(quoteDate).format('YYYY-MM-DD') : undefined), [quoteDate]);
  const budgetStartMonthLabel = useMemo(() => (quoteDate ? dayjs(quoteDate).add(1, 'month').format('MMM YYYY') : ''), [quoteDate]);
  const budgetEndMonthLabel = useMemo(() => (quoteDate ? dayjs(quoteDate).add(12, 'month').format('MMM YYYY') : ''), [quoteDate]);

  const downloadingState = useLoadingState();

  function downloadWorkbook() {
    CommodityManagementApi.getPiedmontHedgingExcelReport(
      downloadingState.setLoadingState,
      customerReportId,
      quoteDateString,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      { responseType: 'blob', headers: { ContentType: Constants.MediaType.Excel } }
    )
      .then(downloadFile)
      .catch((error) => enqueueSnackbar(error?.response?.data?.detail ?? 'The batch report could not be generated.', { variant: 'error' }));
  }

  return (
    <>
      <StoneXRow>
        <StoneXDatePicker label="Marking to Market Date" value={quoteDate} onChange={setQuoteDate} />
        <StoneXButton variant="contained" startIcon={<Download />} isWorking={downloadingState.isLoading()} onClick={downloadWorkbook}>
          Download Workbook
        </StoneXButton>
      </StoneXRow>
      <StoneXRow>
        <p>
          Produces the Hedging MTM and Hedging Position sheets for every location plus the Open Contracts summary, using open
          positions traded on or before the marking to market date for budget months {budgetStartMonthLabel} through {budgetEndMonthLabel}.
        </p>
      </StoneXRow>
    </>
  );
}

export default PiedmontHedgingReport;
